module.exports = __webpack_public_path__ + "img/bracket-round.a6aff9cd.svg";